import { ready } from './helpers';

import ClipboardJS from 'clipboard';

ready(() => {
  new ClipboardJS('#copy-button');
});
